import { create } from "zustand";

/**
 * Какая разбивка показана в панели накопления: по кошелькам или по группам.
 *
 * # Почему переключатель, а не оба блока сразу
 *
 * Сводка по группам приехала в панель над таблицей и на живом рынке заняла ВСЮ
 * высоту карточки: три группы по два исхода — это шесть строк с подписями,
 * плюс основание, плюс покрытие выплат, плюс приписка на четыре строки. Замер
 * на рынке из 855 кошельков: скроллеру таблицы досталось ноль пикселей, то есть
 * разбивки по кошелькам не стало на экране вовсе, а вылезшее из потолка
 * содержимое напечаталось поверх приписок под карточкой.
 *
 * Делить высоту между двумя блоками — значит выдать оператору две прокрутки в
 * одной карточке и по пять строк в каждой; в такой таблице не видно ни сотни
 * кошельков, ни шести строк сводки. Поэтому на экране одна разбивка, и какая —
 * решает оператор: это два ответа на два разных вопроса («куда тянет умная
 * сторона» и «кто стоит крупной ставкой»), а не два измерения одного.
 *
 * # Почему умолчание — кошельки
 *
 * Таблица старше и на ней построена привычка: «я ща ориентируюсь просто по
 * крупным бетам». Сводка — то, за чем приходят осознанно, и один щелчок ей
 * ценой; обратное умолчание отняло бы рабочий экран у того, кто про сводку в
 * этот раз не спрашивал.
 *
 * Стор, а не useState, по той же причине, что у окна статистики и режима: рынки
 * пятиминутные, и локальное состояние сбрасывало бы выбор при каждом переходе
 * на новое окно. Без localStorage — умолчание одинаково у всех вкладок, а
 * сохранённая копия пережила бы даже смену задачи.
 */
export type ParticipantsView = "wallets" | "cohorts";

interface ParticipantsViewStore {
  view: ParticipantsView;
  set: (view: ParticipantsView) => void;
}

export const useParticipantsView = create<ParticipantsViewStore>((set) => ({
  view: "wallets",
  set: (view) => set({ view }),
}));
